<template>
  <div class="cd-section pt-125 pb-300" id="accordion">
    <!--     *********     ACCORDION 1      *********      -->
    <div class="container accordion-1">
      <div class="row">
        <div class="col-md-6 mx-auto text-center">
          <h2 class="title mb-3 mt-1">Informations</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <collapse :multiple-active="false">
            <collapse-item name="1">
              <h5
                slot="title"
                class="mb-0 btn btn-link w-100 text-anhod1 text-left"
              >
                Les paiements sont-ils sécurisés?
                <i class="ni ni-bold-down float-right pt-1"></i>
              </h5>
              <div>
                Notre système de paiement en ligne utilise les services de
                fournisseurs certifiés et spécialisés : Crédit Agricole, Stripe.
                L'ensemble des informations fournis lors du paiement sont
                cryptées.
              </div>
            </collapse-item>
            <collapse-item name="2">
              <h5
                slot="title"
                class="mb-0 btn btn-link w-100 text-anhod2 text-left"
              >
                Puis-je régler ma dette par virement ?
                <i class="ni ni-bold-down float-right pt-1"></i>
              </h5>
              <div>
                Oui, il est tout à fait possible de régler votre dette par
                virement. A cet effet, vous trouverez sur votre espace un bouton
                vous permettant de télécharger notre RIB afin de vous rapprocher
                de votre banque pour effectuer un ou plusieurs virements.
                <br /><b
                  >Attention : Il est indispensable de mentionner votre numéro
                  de dossier dans les références de votre virement.</b
                >
                Si vous ne le faites pas, nous n'arriverons pas à identifier
                votre virement et il ne pourra pas être affecté correctement.
              </div>
            </collapse-item>
            <collapse-item name="3">
              <h5
                slot="title"
                class="mb-0 btn btn-link w-100 text-anhod1 text-left"
              >
                Pourquoi devrais-je vous régler ?
                <i class="ni ni-bold-down float-right pt-1"></i>
              </h5>
              <div>
                Votre créancier nous a mandaté pour assurer le recouvrement
                amiable de sa créance. Dans le respect de la règlementation,
                nous sommes fondés à agir à votre encontre pour réclamer ces
                sommes.
                <br />
                Nous mettons tout en oeuvre pour vous accompagner amiablement
                dans le règlement de vos dettes. Nous essayons de trouver des
                solutions pour ne pas trop pénaliser votre budget.
                <br />
                Ceci dit, si vous refusez de régler sans justification sérieuse,
                notre cabinet pourra faire engager des démarches judiciaires à
                votre encontre. Une fois le titre exécutoire obtenu, nous
                pourrons faire réaliser des saisies (rémunération, compte
                bancaire etc...).
                <br />Pour rappel, tous les frais de recouvrement liés à
                l'exécution d'une décision de justice reste à votre charge.
              </div>
            </collapse-item>
          </collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { HTTP_REQUEST } from "../constants/constantes";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";

export default {
  name: "Informations",
  components: {
    Collapse,
    CollapseItem
  },
  data() {
    return {};
  },
  created: function() {
    this.verifToken();
  },
  methods: {
    verifToken: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let action = "action=VuePaiement";
          let token = "&token=" + self.$store.state.tokens;
          var postData = action + token;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID") {
              self.$store.commit("removeToken", 0);
              self.$store.commit("removeSolde", 0);
              router.push("/login/1/0/0");
            } else if (retourApi.data == "INVALID PARAMS") {
              router.push("/login/1/0/0");
            }
          }
        });
      } else {
        router.push("/login/1/0/0");
      }
    }
  }
};
</script>

<style scoped>
.title {
  color: #222;
}
div {
  color: #222;
}
.cd-section {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
  padding-block-end: 20rem;
}
</style>
